module.exports = __webpack_public_path__ + "img/undraw_navigation_lytx.e41b5ab9.svg";